<template>
  <div v-loading="dataLoading" class="notice-detail">
    <div class="notice-detail-title">{{detailInfo.title}}</div>
    <div class="notice-detail-time">{{detailInfo.createTime}}</div>
    <div class="notice-detail-content">{{detailInfo.content}}</div>
    <div v-if="linkMap[detailInfo.title]" class="margin-top-10">
      <p v-for="(item, index) in linkMap[detailInfo.title]" :key="index" class="margin-bottom-4" @click="onLink(item)">
        <span class="margin-left-26 margin-right-12">{{index + 1}}.</span><span class="link-text">{{item}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import NoticeService from '@/views/content/api/notice';

export default {
  data() {
    return {
      dataLoading: false,
      detailInfo: {},
      linkMap: {
        查询详情页优化公告: [
          '交易详情功能更新公告.pdf',
          '退款详情功能更新公告.pdf',
          '拒付详情页面功能上线公告.pdf',
        ],
        'Transaction Details Page Optimization Notice': [
          'Transaction Details Page Update Notice.pdf',
          'Refund Details Page Update Notice.pdf',
          'Chargeback Details Pag Launch Notice.pdf',
        ],
      },
    };
  },
  created() {
    const id = this.$route.query.id;
    this.fetchNoticeDetail(id);
  },
  watch: {
    $route: function(to) {
      const id = to.query.id;
      this.fetchNoticeDetail(id);
    },
  },
  methods: {
    async fetchNoticeDetail(id) {
      this.dataLoading = true;
      try {
        const res = await NoticeService.queryDetail(id);
        this.detailInfo = res;
        NoticeService.readNotice({ announcementId: id }).then(() => {
          this.$store.dispatch('app/refreshNotice');
        });
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    onLink(name) {
      window.open(`/static/files/${name}`, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.notice-detail {
  width: 60%;
  padding-top: 20px;
  .notice-detail-title {
    font-size: 22px;
    font-family: AvenirNext-DemiBold, AvenirNext;
    font-weight: 600;
    color: $color-text-primary;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .notice-detail-time {
    font-size: 14px;
    font-family: AvenirNext-Regular, AvenirNext;
    font-weight: 400;
    color: rgba(38,67,115,0.3);
    line-height: 20px;
    margin-bottom: 20px;
  }

  .notice-detail-content {
    font-size: 14px;
    font-family: AvenirNext-Regular, AvenirNext;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 20px;
  }

  .link-text {
    font-size: 14px;
    font-family: AvenirNext-Regular, AvenirNext;
    font-weight: 400;
    color: $color-text-default-button;
    line-height: 20px;
    cursor: pointer;
    text-decoration-line: underline;
  }
}
</style>
